<template>
  <div>
    <div style="border: 1px solid #ccc">
      <Toolbar
        ref="toolbar"
        style="border-bottom: 1px solid #ccc"
        :editor="editor"
        :defaultConfig="toolbarConfig"
        :mode="mode"
      />
      <Editor
        ref="editor"
        style="height: 50rem; overflow-y: hidden"
        v-model="html"
        :defaultConfig="editorConfig"
        :mode="mode"
        @onCreated="onCreated"
        @onChange="onChange"
      />
    </div>
  </div>
</template>
  <script>
import { Editor, Toolbar } from "@wangeditor/editor-for-vue";
import { DomEditor } from "@wangeditor/editor";
import axios from "axios";

export default {
  name: "editorVue",
  components: { Editor, Toolbar },
  props: {
    myHtml: {
      type: String,
      default: ""
    },
    myitemId: {
      type: Number,
      default: 0
    },
    myEditorType: {
      type: String,
      default: ""
    },
    edit: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      editor: null,
      html: "",
      itemId: 0,
      editorType: "",
      toolbarConfig: {
        // excludeKeys: [
        //   // 排除菜单组，写菜单组 key 的值即可
        //   "headerSelect", //去掉正文
        //   "blockquote", //去掉引用
        //   "color", //去掉字体颜色
        //   "bgColor", //去掉背景颜色
        //   "fontSize", //去掉默认字号
        //   "fontFamily", //去掉默认字体
        //   "lineHeight", //去掉默认行高
        //   "bulletedList", //去掉无序列表
        //   "numberedList", //去掉有序列表
        //   "todo", //去掉待办
        //   "group-justify", //去掉缩进
        //   "group-indent", //去掉对齐
        //   "emotion", //去掉表情包
        //   "insertLink", //去掉链接
        //   "group-video", //去掉视频
        //   "insertImage", //去掉网络图片上传
        //   "insertTable", //去掉表格
        //   "divider", //去掉分割线
        //   "fullScreen" //去掉全屏
        // ]
      },
      editorConfig: {
        placeholder: "请输入内容...",
        // 所有的菜单配置，都要在 MENU_CONF 属性下
        MENU_CONF: {
          //配置上传图片
          uploadImage: {
            allowImageRemote: false,
            customUpload: this.uploadImg
            // // 单个文件的最大体积限制，默认为 2M
            // maximgSize: 10 * 1024 * 1024, // 10M
            // // 最多可上传几个文件，默认为 100
            // maxNumberOfimgs: 10,
            // // 选择文件时的类型限制，默认为 ['image/*'] 。如不想限制，则设置为 []
            // allowedimgTypes: ["image/*"]
          }
        }
      },
      mode: "default"
    };
  },
  watch: {
    myHtml: {
      handler(val) {
        this.html = val;
      },
      deep: true
    },
    edit(val) {
      //console.log(val)
      if (val) {
        this.editor.enable();
      } else {
        this.editor.disable();
        this.editor.focus(true);
      }
    }
  },
  created() {
    this.getVal();
  },

  computed: {},
  methods: {
    getVal() {
      //父组件获取子组件的值
      if (this.myHtml !== "") {
        this.html = this.myHtml;
      }
      if (this.myitemId) {
        this.itemId = this.myitemId;
      }
      if (this.myEditorType) {
        this.editorType = this.myEditorType;
      }
    },
    onChange() {
      let editor = {
        html: this.html,
        itemId: this.itemId,
        editorType: this.editorType
      };
      this.$emit("handleMyEditor", editor);
    },
    //上传图片
    uploadImg(file, insertFn) {
      let imgData = new FormData();
      imgData.append("file", file);
      let url = base_url + "SubjectController/InsertFile";

      axios.post(url, imgData).then(res => {
        if (res.data.status === 0) {
       
        let imgurl=base_url_src+res.data.data
          insertFn(imgurl);
        } else {
          throw new Error("添加失败！");
        }
      });
    },
    onCreated(editor) {
      this.editor = Object.seal(editor); // 一定要用 Object.seal() ，否则会报错
      if (!this.edit) {
        editor.disable();
      }
    }
  },
  updated() {
    // const toolbar = DomEditor.getToolbar(this.editor);
    // const curToolbarConfig = toolbar.getConfig();
    //console.log(curToolbarConfig);
    //console.log(this.editor.getAllMenuKeys());
  },
  beforeDestroy() {
    const editor = this.editor;
    if (editor == null) return;
    editor.destroy(); // 组件销毁时，及时销毁编辑器
  }
};
</script>
  <style src="@wangeditor/editor/dist/css/style.css"></style>
  


// WEBPACK FOOTER //
// src/components/Common/EditorVue.vue